/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Modal } from "react-bootstrap";
import BaseCom from "./BaseCom";
import SignatureCanvas from "react-signature-canvas";
import React from "react";
import L from "./Lang";

export default class SignatureModal extends BaseCom {
    constructor(props) {
        super(props);
        this.sigCanvasRef = React.createRef();
    }

    submit = e => {
        e?.preventDefault();
        if (this.sigCanvasRef.current.isEmpty()) {
            this.alert('Please sign the form before submitting.');
            return;
        }
        var sig = this.sigCanvasRef.current.getTrimmedCanvas().toDataURL('image/png').split(',')[1];
        this.props.onSave(sig);
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{this.props.title || 'Signature'}</Modal.Title>
            </Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    <div className="text-center">
                        <i><L>Please sign in the box below</L></i>
                    </div>
                    <div className="d-grid align-items-center justify-content-center">
                        <SignatureCanvas
                            ref={this.sigCanvasRef}
                            canvasProps={{ width: 400, height: 200, className: 'border' }} />
                        <button type="button" className="btn btn-secondary" onClick={() => this.sigCanvasRef.current.clear()}>Clear Signature</button>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {!this.props.signing ? <div>
                        <button type="submit" className="btn btn-primary" disabled={this.props.signing}>Save</button>
                        <button type="button" className="btn btn-secondary" onClick={this.props.onHide} disabled={this.props.signing}>Close</button>
                    </div> : <p>{this.props.signing}</p>}
                </Modal.Footer>
            </form>
        </Modal>
    }
}